const VAPID_PUBLIC_KEY = 'BNMbzSYNSx_6bsRYtsYOQ87aqKFkbTTpJrwrCBP_ebdSj60_zVYv8GxLHgWv5Ls2186UPAUD33nTC8MbF7rTBKU';
export async function registerPush() {
  console.log('开始注册推送');
  if (!window.__baseInfo.userId) {
      console.error('用户未登录，无法注册推送');
      return;
  }

  try {
      const applicationServerKey = urlBase64ToUint8Array(VAPID_PUBLIC_KEY);

      console.log('等待 Service Worker 注册完成...');
      // 等待 Service Worker 注册完成 
      const registration = await navigator.serviceWorker.ready;
      console.log('Service Worker 已准备好:', registration.active, registration);

      // 订阅推送
      const subscription = await registration.pushManager.subscribe({
          userVisibleOnly: true,
          applicationServerKey,
          // applicationServerKey: btoa(VAPID_PUBLIC_KEY),
      }).catch(error => {
          console.error('订阅失败:', error);
      });

      console.log('Subscription:', subscription);
      // console.log('keys:', subscription.getKey('p256dh'), subscription.getKey('auth'));

      // 将订阅信息发送到服务器
      const response = await fetch('/api/push/register', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            userId: window.__baseInfo.userId,
            endpoint: subscription.endpoint,
            p256dh: arrayBufferToBase64(subscription.getKey('p256dh')),
            auth: arrayBufferToBase64(subscription.getKey('auth')),
          }),
      });

      if (!response.ok) {
        console.log(`服务器返回错误: ${response.status}`);
        return false;
      }

      console.log('推送注册成功');
      return true;

  } catch (error) {
      console.error('推送注册失败:', error);
      return false;
  }
}

export function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding)
    .replace(/\-/g, '+')
    .replace(/_/g, '/');

  const rawData = window.atob(base64);
  const uint8Array = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    uint8Array[i] = rawData.charCodeAt(i);
  }
  return uint8Array;
}

// 提取 p256dh 和 auth
export function arrayBufferToBase64(buffer) {
  let binary = '';
  const bytes = new Uint8Array(buffer);
  for (let i = 0; i < bytes.byteLength; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return btoa(binary); // 转换为 Base64 编码
}